import React, { useEffect } from 'react';
import ThemeSettings from 'features/ThemeSettings/ui/ThemeSettings';
import {
	useCustomerJourneyMutationQuery,
	useJourneyResultCampaignIdQuery
} from 'entities/ApplicationForm/hooks/queries';
import { theme } from 'shared/config/theme/theme';
import { Container, ThemeProvider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkParamType } from 'shared/utils/checkParamType';
import Loader from 'shared/ui/Loader/Loader';

interface ThemeSettingsWrapperProps {
	children?: React.ReactNode;
}

const ThemeSettingsWrapper = (props: ThemeSettingsWrapperProps) => {
	const location = useLocation();
	const { search } = location;
	const navigate = useNavigate();
	const { mutateAsync: fetchForm, isSuccess, isError, isPending } = useCustomerJourneyMutationQuery();
	const campaignIdQuery = useJourneyResultCampaignIdQuery()
	const params = new URLSearchParams(search);
	const client_id: string = params.get('client_id') || localStorage.getItem('client_id') || "";
	const type: string = params.get('type') || checkParamType(client_id) || "";


	// Call fetchForm to get the data
	useEffect(() => {
		const getData = async () => {
			try {
				if (client_id) {
					await fetchForm(client_id);
				}
			} catch (e) {
				console.log('Error fetching form data:', e);
			}
		};

		void getData();
	}, [fetchForm]);

	useEffect(() => {
		if ((!client_id || isError)) {
			navigate("/error");
		}
	}, [isError])

	useEffect(() => {
		if (isSuccess && client_id) {
			localStorage.setItem("client_id", client_id);
			if (type) {
				localStorage.setItem("type", JSON.stringify({ type, client_id }));
			}
			if (!type && !checkParamType(client_id)) {
				localStorage.removeItem("type");
			}
		}
	}, [isSuccess, client_id]);

	if (isPending) {
		return <ThemeProvider theme={theme}><Loader/></ThemeProvider>
	}

	return (
		<ThemeSettings campaignId={campaignIdQuery?.campaignId ?? null}>
			<Container
				maxWidth={"lg"}
				sx={{ backgroundColor: (theme) => theme.palette.global.main }}>
				{props.children}
			</Container>
		</ThemeSettings>
	);
};

export default ThemeSettingsWrapper;
